import { AppState, DateRange, PageProps, Session } from "@declarations"
import { getTrafficTotalsByRegion } from "Store/Actions/DataActions-Demographics"
import Table from "Components/Table/Table"
import { useEffect } from "react"
import Skeleton from "react-loading-skeleton"
import { connect } from "react-redux"
import { store } from "Store/store"
import { callCheck } from "Utils/data"

interface Props extends PageProps<typeof mapStateToProps, typeof mapDispatchToProps> {
}

const TrafficTotalsTable = (props: Props) => {

    const { session, globalView, experiences, dates, dataList, getDataList, loadingData, demoBrandActive } = props

    useEffect(() => {

        if (!callCheck(globalView, (session as Session.AuthSession).user.admin, experiences?.length)) return

        getDataList(dates)

    }, [getDataList, session, demoBrandActive, dates, experiences, globalView])

    return (
        <div className="">
            {
                loadingData
                    ? <Skeleton height={250} />
                    : dataList && dataList.length
                        ? <Table
                            title="Traffic totals by region"
                            showTitle={true}
                            headers={Object.keys(dataList[0])}
                            sortable={["experienceOpens"]}
                            data={dataList}
                            limit={10}
                            pagination={true}
                            showDownloadCSV={true}
                        />
                        : null
            }
        </div>
    )
}

const mapStateToProps = (state: AppState) => {
    return {
        session: state.session,
        experiences: state.experiences.experienceIdList,
        globalView: state.experiences.globalView,
        demoBrandActive: state.experiences.demoBrandActive,
        dataList: state.data.demographics.trafficTotalsByRegion,
        dates: state.dates.demographics.scansByLocation, // updates with scans by location map's date selector
        loadingData: state.loading.demographics.trafficTotalsByRegion
    }
}
const mapDispatchToProps = (dispatch: typeof store.dispatch) => {
    return {
        getDataList: (dates: DateRange) => dispatch(getTrafficTotalsByRegion(dates))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(TrafficTotalsTable)